import React, { useEffect, useState } from "react";
import { Card, Checkbox, Button, Select } from "antd";
import StoreImage from "../../assets/images/store-game-img.png";
import Main from "../../components/layout/Main";
import { useNavigate } from "react-router";
import ForSliders from "../../components/forsliders";
import { ChevronDown, Clock, Star } from "lucide-react";
import { useStore } from "../../context/StoreContext";
import { useGlobalSearch } from "../../context/GlobalSearchContext";
import {
  DEFAULT_LIMIT,
  DEFAULT_PAGE,
  isScrollAtBottom,
  isValidUrl,
} from "../../helper/functions";
import { ImageNotAvailable } from "../../constants/urls";
const { Option } = Select;

const StorePage = () => {
  const { loadStores, filters, updateFilters } = useStore();
  const navigate = useNavigate();
  const [activeMode, setActiveMode] = useState("All");
  const [sortValue, setSortValue] = useState("newest");
  const [stores, setStores] = useState([]);
  const [featuredStores, setFeaturedStores] = useState([]);
  const { globalSearch } = useGlobalSearch();
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [hasMore, setHasMore] = useState(true);
  const limit = DEFAULT_LIMIT;

  // When user selects a sorting option
  const handleChange = (value) => {
    setSortValue(value);
    updateFilters({ sortBy: value });
  };

  // ------------ Handlers -----------
  const fetchStores = async (reset = false) => {
    const response = await loadStores({ page, limit });
    if (response.status === 200) {
      if (reset) {
        setStores(response.data.data);
        setFeaturedStores(response.data.featured_stores);
      } else {
        setStores((prev) => [...prev, ...response.data.data]);
        setFeaturedStores(response.data.featured_stores);
      }

      // if no more data → stop loading more
      if (response.data.length < limit) {
        setHasMore(false);
      }
    }
  };

  const handleScroll = (e) => {
    if (isScrollAtBottom(e) && hasMore) {
      setPage((prev) => prev + 1);
    }
  };

  // ------------ Effects -----------

  useEffect(() => {
    setPage(DEFAULT_PAGE);
    setHasMore(true);
    fetchStores(true);
  }, [filters, globalSearch]);

  useEffect(() => {
    updateFilters({ searchQuery: globalSearch });
  }, [globalSearch]);

  useEffect(() => {
    if (page > 1) {
      fetchStores();
    }
  }, [page]);

  useEffect(() => {
    fetchStores();
  }, [filters]);

  return (
    <>
      <Main>
        <div className="section-main">
          <ForSliders />
          {/* ------------- Featured Stores Section ---------- */}
          <section className="for-upcoming-tumanents">
            <div className="orange-header">Featured Stores</div>
            <div className="store-featured-card-main">
              {featuredStores.map((store, index) => (
                <div
                  key={index}
                  className="store-featured-card"
                  onClick={() => navigate(`/stores/${store._id}`)}
                >
                  <div className="store-featured-card-images">
                    <img
                      src={
                        isValidUrl(store.profileImage)
                          ? store?.profileImage
                          : ImageNotAvailable
                      }
                    />
                  </div>
                  <div className="store-featured-card-details">
                    <h6>{store?.name}</h6>
                    <div className="store-gamming-time">
                      <Clock /> <span>{store?.time}</span>
                    </div>
                    <div className="store-gamming-ratting">
                      <Star />
                      <span>{store?.rating}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
          {/* ------------- Next Stores Section ---------- */}
          <section className="for-upcoming-tumanents ">
            <div className="contant-select-headding">
              <div className="custome-headding-leftbar">
                <div className="orange-header">All Stores</div>
                <div className="game-modes-filter">
                  {["All"].map((mode) => (
                    <Button
                      key={mode}
                      type={activeMode === mode ? "primary" : "default"}
                      onClick={() => {
                        setActiveMode(mode);
                        updateFilters({ category: mode });
                      }}
                      className="mode-filter-btn"
                    >
                      {mode}
                    </Button>
                  ))}
                </div>
              </div>
              <div className="custome-headding-rightbar">
                <div className="sort-dropdown-wrapper">
                  <label className="sort-label">Sort by</label>
                  <Select
                    value={sortValue}
                    onChange={handleChange}
                    className="custom-sort-dropdown"
                    suffixIcon={<ChevronDown style={{ color: "#fff" }} />}
                  >
                    <Option value="newest">
                      Newest to Oldest (Newest First)
                    </Option>
                    <Option value="oldest">
                      Oldest to Newest (Oldest First)
                    </Option>
                    <Option value="az">A - Z</Option>
                    <Option value="za">Z - A</Option>
                  </Select>
                </div>
              </div>
            </div>
            {/* --------- Stores -------- */}
            <div
              className="store-featured-card-main main-store-section"
              onScroll={handleScroll}
            >
              {stores.map((store, index) => (
                <div
                  className="store-featured-card"
                  key={index}
                  onClick={() => navigate(`/stores/${store._id}`)}
                >
                  <div className="store-featured-card-images">
                    <img
                      src={
                        isValidUrl(store.profileImage)
                          ? store.profileImage
                          : ImageNotAvailable
                      }
                    />
                  </div>
                  <div className="store-featured-card-details">
                    <h6>{store?.name}</h6>
                    <div className="store-gamming-time">
                      <Clock /> <span>{store?.time}</span>
                    </div>
                    <div className="store-gamming-ratting">
                      <Star />
                      <span>{store?.rating}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </Main>
    </>
  );
};

export default StorePage;
